module.exports = __webpack_public_path__ + "static/img/banner2.161ad21.png";


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/onlinePreview/banner2.png
// module id = /ipX
// module chunks = 2